import React from 'react';
import { RadioGroup } from '@atlaskit/radio';
import { DisplayMode } from '../../RenderForm';
import { ChoiceQuestionStyles } from '../common/commonStyles';
import { ChoiceFieldWrapper, ChoicePlaceholder } from '../common/questionWrappers';
import { ViewOtherOption } from './ViewOtherOption';
export const ViewSingleChoice = ({
  id,
  value,
  options,
  hasOtherOption,
  otherOptionText,
  displayMode
}) => {
  return /*#__PURE__*/React.createElement(ChoiceFieldWrapper, {
    isDisabled: true,
    isView: displayMode === DisplayMode.View
  }, options !== null && options !== void 0 && options.length ? /*#__PURE__*/React.createElement(ChoiceQuestionStyles, null, options.map((option, index) => /*#__PURE__*/React.createElement(RadioGroup, {
    key: index,
    name: id,
    value: value === null || value === void 0 ? void 0 : value.value,
    options: [option],
    isDisabled: true
  }))) : /*#__PURE__*/React.createElement(ChoicePlaceholder, null), otherOptionText && /*#__PURE__*/React.createElement(ViewOtherOption, {
    dropdown: false,
    display: hasOtherOption,
    value: otherOptionText
  }));
};